module.exports = __webpack_public_path__ + "assets/rtc.504f3939.svg";